export const INDUSTRY_OPTIONS = [
    { value: 'food_hospitality', label: '飲食・接客業' },
    { value: 'retail_sales', label: '小売・販売業' },
    { value: 'service', label: 'サービス業' },
    { value: 'school', label: 'スクール・教育業' },
    { value: 'salon', label: 'サロン業' },
    { value: 'multi_store_hq', label: '多店舗・本部管理' },
    { value: 'medical', label: '医療・クリニック' }
];

const COMMON_CHALLENGES = [
    { value: 'manual_work', label: '紙・手作業が多く運用負荷が高い' },
    { value: 'data_scattered', label: '情報が分散していて確認に時間がかかる' },
    { value: 'input_errors', label: '入力ミス・運用ミスを減らしたい' },
    { value: 'visibility', label: '状況をリアルタイムで可視化したい' }
];

const COMMON_FEATURES = [
    { value: 'dashboard', label: 'ダッシュボード・集計画面' },
    { value: 'workflow_standardization', label: '業務フローの標準化' },
    { value: 'permission_control', label: '権限管理・承認フロー' },
    { value: 'notifications', label: '通知・アラート機能' }
];

export const HEARING_OPTIONS_BY_INDUSTRY = {
    food_hospitality: {
        challenges: [
            ...COMMON_CHALLENGES,
            { value: 'receipt_busy_time', label: 'ピーク時の領収書・会計対応が大変' },
            { value: 'reservation_customer_split', label: '予約・顧客・売上管理が分かれている' },
            { value: 'attendance_management', label: 'スタッフ打刻・勤怠管理が煩雑' }
        ],
        features: [
            ...COMMON_FEATURES,
            { value: 'receipt_issuance', label: '領収書発行・再発行管理' },
            { value: 'qr_attendance', label: 'QR打刻・勤怠記録' },
            { value: 'customer_reservation_sales', label: '顧客・予約・売上の一元管理' },
            { value: 'bottle_management', label: 'ボトル管理・来店履歴管理' }
        ]
    },
    retail_sales: {
        challenges: [
            ...COMMON_CHALLENGES,
            { value: 'inventory_gap', label: '在庫・個別商品の把握に時間がかかる' },
            { value: 'takeaway_reserve', label: '取り置き・来店対応の管理が難しい' },
            { value: 'store_aggregation', label: '店舗ごとの確認作業が多い' }
        ],
        features: [
            ...COMMON_FEATURES,
            { value: 'inventory_management', label: '在庫・個別商品管理' },
            { value: 'reserve_management', label: '取り置き・来店対応管理' },
            { value: 'pos_receipt', label: '会計・領収書・印刷管理' },
            { value: 'sales_analytics', label: '売上分析・日次集計' }
        ]
    },
    service: {
        challenges: [
            ...COMMON_CHALLENGES,
            { value: 'reception_operational_load', label: '受付・予約対応の属人化' },
            { value: 'support_history_missing', label: '対応履歴を追えない' },
            { value: 'staff_operation_mismatch', label: 'スタッフ間で運用ルールがずれる' }
        ],
        features: [
            ...COMMON_FEATURES,
            { value: 'reservation_management', label: '予約・スケジュール管理' },
            { value: 'customer_history', label: '顧客対応履歴管理' },
            { value: 'attendance_staff', label: 'スタッフ打刻・勤怠管理' },
            { value: 'document_print', label: '帳票出力・印刷管理' }
        ]
    },
    school: {
        challenges: [
            ...COMMON_CHALLENGES,
            { value: 'student_parent_split', label: '生徒・保護者情報が分散している' },
            { value: 'lesson_booking_manual', label: '体験授業・面談予約の調整が手作業' },
            { value: 'attendance_admin_cost', label: '出欠・請求関連の事務負荷が高い' }
        ],
        features: [
            ...COMMON_FEATURES,
            { value: 'student_parent_management', label: '生徒・保護者情報管理' },
            { value: 'lesson_booking', label: '体験授業・面談・補講予約管理' },
            { value: 'attendance_tracking', label: '出欠・講師勤怠管理' },
            { value: 'tuition_receipt', label: '月謝請求・領収書管理' }
        ]
    },
    salon: {
        challenges: [
            ...COMMON_CHALLENGES,
            { value: 'appointment_fragmented', label: '施術予約管理が分散している' },
            { value: 'repeat_visit_tracking', label: '来店履歴・再来店フォローが難しい' },
            { value: 'staff_shift_visibility', label: 'スタッフシフト・打刻の可視化不足' }
        ],
        features: [
            ...COMMON_FEATURES,
            { value: 'treatment_booking', label: '施術予約・担当管理' },
            { value: 'customer_visit_history', label: '顧客・来店履歴管理' },
            { value: 'store_sales_products', label: '売上・店販管理' },
            { value: 'staff_attendance', label: 'スタッフ打刻・勤怠管理' }
        ]
    },
    multi_store_hq: {
        challenges: [
            ...COMMON_CHALLENGES,
            { value: 'hq_visibility', label: '本部で店舗状況を把握しづらい' },
            { value: 'rule_inconsistency', label: '店舗ごとに運用ルールがバラつく' },
            { value: 'reporting_delay', label: '集計・報告にタイムラグがある' }
        ],
        features: [
            ...COMMON_FEATURES,
            { value: 'multi_store_dashboard', label: '多店舗ダッシュボード' },
            { value: 'store_comparison', label: '店舗別比較・集計' },
            { value: 'hq_approval', label: '本部承認フロー' },
            { value: 'attendance_sales_link', label: '勤怠・売上の横断管理' }
        ]
    },
    medical: {
        challenges: [
            ...COMMON_CHALLENGES,
            { value: 'medical_flow_slow', label: '受付から会計までの流れをもっとスムーズにしたい' },
            { value: 'medical_reservation_split', label: '予約・問診・患者情報が分散している' },
            { value: 'medical_attendance_shift', label: '勤怠管理やシフト調整に時間がかかる' },
            { value: 'medical_data_decision', label: '経営データをリアルタイムで把握したい' }
        ],
        features: [
            ...COMMON_FEATURES,
            { value: 'medical_reservation', label: '予約管理・変更管理' },
            { value: 'medical_interview', label: 'オンライン問診フォーム' },
            { value: 'medical_reception', label: '受付状況の一覧管理' },
            { value: 'medical_billing', label: '会計・請求管理' },
            { value: 'medical_receipt_documents', label: '領収書・帳票発行管理' },
            { value: 'medical_staff_attendance', label: 'スタッフ管理・勤怠管理' },
            { value: 'medical_inventory', label: '在庫管理（医療材料・備品）' },
            { value: 'medical_analytics', label: 'ダッシュボード・データ分析' }
        ]
    }
};

export const PROJECT_PHASE_OPTIONS = [
    { value: 'research', label: '情報収集段階' },
    { value: 'planning', label: '要件整理・企画中' },
    { value: 'short_term', label: '3か月以内に検討したい' },
    { value: 'urgent', label: 'なるべく早く進めたい' }
];

export const PURPOSE_OPTIONS_BY_MODE = {
    download: [
        { value: 'request_materials', label: '資料請求' },
        { value: 'compare_solutions', label: 'サービス比較・検討' },
        { value: 'cost_estimate', label: '費用感を知りたい' },
        { value: 'discussion_after_reading', label: '資料確認後に相談したい' }
    ],
    contact: [
        { value: 'online_consultation', label: 'オンライン相談を予約したい' },
        { value: 'service_inquiry', label: 'サービスについて相談したい' },
        { value: 'estimate_inquiry', label: 'お見積りを相談したい' },
        { value: 'other_inquiry', label: 'その他のお問い合わせ' }
    ]
};

const RETAIL_LANDING_PAGE_CONTENT = {
    eyebrow: 'CASE STUDY / 小売・販売業',
    heroTitle: '小売・販売業の運営を、ひとつの仕組みに。',
    heroDescription: '領収書・印刷・打刻・顧客・売上を、現場で使いやすく本部で確認しやすい形に整理した導入例です。',
    primaryCtaLabel: 'この内容で相談する',
    secondaryCtaLabel: '資料請求・お問い合わせへ戻る',
    valuePoints: [
        '紙・手作業・個別管理からの脱却',
        '店長・本部・エリアマネージャーの確認負荷を削減',
        '販売現場のオペレーションを標準化しやすい構成'
    ],
    sections: [
        {
            title: '想定していた主な課題',
            items: [
                '領収書発行や再発行をスムーズにしたい',
                '商品・顧客・売上情報をまとめて管理したい',
                '印刷トラブルの原因を把握しやすくしたい',
                'スタッフの出退勤を簡単に記録したい'
            ]
        },
        {
            title: '実装した機能カテゴリ',
            items: [
                '領収書発行・再発行管理、印刷管理',
                'QR打刻・スタッフ勤怠管理',
                '顧客管理・商品管理・在庫管理',
                '取り置き・来店対応・予約管理、売上管理'
            ]
        },
        {
            title: '得られた効果',
            items: [
                '手作業と確認工数を削減',
                '入力ルール統一で運用ミスを抑制',
                '履歴可視化により原因特定を高速化',
                '本部の意思決定スピードを向上'
            ]
        }
    ]
};

// TODO: 業種別LPを展開する際は industry ごとにマッピングする
export const getIndustryLandingContent = () => RETAIL_LANDING_PAGE_CONTENT;

export const getHearingOptions = (industry) => HEARING_OPTIONS_BY_INDUSTRY[industry] || {
    challenges: COMMON_CHALLENGES,
    features: COMMON_FEATURES
};

export const findLabel = (options, value) => {
    const matched = options.find((option) => option.value === value);
    return matched ? matched.label : value;
};
